import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Lock, ArrowRight } from "lucide-react";
import { sfx } from "../../services/soundfx";
import { speak } from "../../services/phonicsAudio";

export default function Cliffhanger({ cliffhanger, onUnlock, onBack }) {
  const [line, setLine] = useState(0);
  const lines = cliffhanger.lines;

  useEffect(() => {
    sfx.fanfare();
    speak(lines[0]);
  }, []); // eslint-disable-line

  const next = () => {
    if (line + 1 < lines.length) {
      const n = line + 1;
      setLine(n);
      sfx.tap();
      speak(lines[n]);
    }
  };
  const isLast = line + 1 >= lines.length;

  return (
    <div className="fixed inset-0 z-[95] flex items-center justify-center p-4 no-select" style={{ background: "linear-gradient(180deg,#1E1B4B,#312E81)" }} data-testid="cliffhanger">
      <motion.div initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} className="w-full max-w-md text-center">
        <motion.div animate={{ y: [0, -12, 0], rotate: [-3, 3, -3] }} transition={{ repeat: Infinity, duration: 3 }} className="text-[7rem] leading-none mb-2">
          {cliffhanger.emoji}
        </motion.div>
        <h2 className="font-display text-3xl font-black text-amber-300 mb-5">{cliffhanger.title}</h2>

        <motion.p key={line} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} className="font-display text-lg font-bold text-indigo-100 min-h-[84px] mb-6 px-2">
          {lines[line]}
        </motion.p>

        <div className="flex gap-2 justify-center mb-6">
          {lines.map((_, i) => (
            <div key={i} className={`w-2.5 h-2.5 rounded-full ${i <= line ? "bg-amber-300" : "bg-indigo-700"}`} />
          ))}
        </div>

        {!isLast ? (
          <button data-testid="cliffhanger-next" onClick={next} className="pop-btn inline-flex items-center gap-2 rounded-full bg-indigo-500 text-white font-display text-lg font-bold px-7 py-3.5 border-4 border-white/30 active:shadow-none">
            Next <ArrowRight strokeWidth={3} />
          </button>
        ) : (
          <div className="flex flex-col gap-3">
            <button data-testid="cliffhanger-unlock" onClick={() => { sfx.tap(); onUnlock(); }} className="pop-btn inline-flex items-center justify-center gap-2 rounded-full bg-amber-400 text-indigo-900 font-display text-lg font-black px-7 py-4 border-4 border-white shadow-[0_6px_0_#B45309] active:shadow-none">
              <Lock strokeWidth={3} /> Continue the Adventure (Grown-ups)
            </button>
            <button data-testid="cliffhanger-back" onClick={() => { sfx.tap(); onBack(); }} className="font-bold text-indigo-200 underline">
              Back to the caves
            </button>
          </div>
        )}
      </motion.div>
    </div>
  );
}
